import { Box } from '@mui/material';
import { ChecklistItemType, ViewChecklistItem } from 'src/models/unit';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import ShortTextOutlinedIcon from '@mui/icons-material/ShortTextOutlined';
import NumbersOutlinedIcon from '@mui/icons-material/NumbersOutlined';
import LinearScaleOutlinedIcon from '@mui/icons-material/LinearScaleOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import ContrastIcon from '@mui/icons-material/Contrast';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { FeatureStatus } from 'src/models/feature.toggle';
import { ReportChecklistItem } from 'src/models/report';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { MediaBox } from '../styled';
import { Check, CheckBoxOutlineBlankOutlined } from '@mui/icons-material';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';

export const isDisabledMandatoryControl = (item: ViewChecklistItem) => {
  if (isCheckBox(item)) {
    return true;
  }
  return false;
};

export const getChecklistItemAllowedTypes = (type: ChecklistItemType) => {
  const showCheckAndRadio =
    process.env.REACT_APP_CHECK_RADIO == FeatureStatus.ENABLED;

  let excludedTyped = [
    ChecklistItemType.MEDIA,
    ChecklistItemType.MULTIPLE_CHOICE
  ];

  if (!showCheckAndRadio) {
    excludedTyped = excludedTyped.concat([
      ChecklistItemType.RADIO_BUTTON,
      ChecklistItemType.CHECK_BOX
    ]);
  }

  return Object.values(ChecklistItemType).filter(
    (t) => !excludedTyped.includes(t)
  );
};

export const getType = (
  { type, t }: { type: ChecklistItemType; t: any },
  closed = false
) => {
  const translatedText = t(`CHECKLIST_ITEM_TYPE.${type}`);
  if (type === ChecklistItemType.TEXT) {
    return (
      <Box display="flex" alignItems="center">
        <ShortTextOutlinedIcon fontSize="small" />
        <Box padding={0.7} />
        {translatedText}
      </Box>
    );
  }
  if (type === ChecklistItemType.NUMBER) {
    return (
      <Box display="flex" alignItems="center">
        <NumbersOutlinedIcon fontSize="small" />
        <Box padding={0.7} />
        {translatedText}
      </Box>
    );
  }
  if (type === ChecklistItemType.CONDITION) {
    return (
      <Box display="flex" alignItems="center">
        <LinearScaleOutlinedIcon fontSize="small" />
        <Box padding={0.7} />
        {translatedText}
      </Box>
    );
  }
  if (type === ChecklistItemType.CHECK_BOX) {
    return (
      <Box display="flex" alignItems="center">
        <CheckBoxOutlineBlankOutlinedIcon fontSize="small" />
        <Box padding={0.7} />
        {translatedText}
      </Box>
    );
  }
  if (type === ChecklistItemType.RADIO_BUTTON) {
    return (
      <Box display="flex" alignItems="center">
        <RadioButtonCheckedOutlinedIcon fontSize="small" />
        <Box padding={0.7} />
        {translatedText}
      </Box>
    );
  }
  if (type === ChecklistItemType.SIGNATURE) {
    return (
      <Box display="flex" alignItems="center">
        <svg
          width="20"
          height="20"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.71667 7.81732C9.52778 7.21732 10.1611 6.55898 10.6167 5.84232C11.0722 5.12565 11.3 4.41176 11.3 3.70065C11.3 3.3451 11.2417 3.08398 11.125 2.91732C11.0083 2.75065 10.85 2.66732 10.65 2.66732C10.1278 2.66732 9.66667 3.10898 9.26667 3.99232C8.86667 4.87565 8.66667 5.87287 8.66667 6.98398C8.66667 7.13954 8.66944 7.28676 8.675 7.42565C8.68055 7.56454 8.69444 7.6951 8.71667 7.81732ZM1.33333 14.0007V12.6673H2.66667V14.0007H1.33333ZM4 14.0007V12.6673H5.33333V14.0007H4ZM6.66667 14.0007V12.6673H8V14.0007H6.66667ZM9.33333 14.0007V12.6673H10.6667V14.0007H9.33333ZM12 14.0007V12.6673H13.3333V14.0007H12ZM1.6 11.334L0.666666 10.4007L1.73333 9.33398L0.666666 8.26732L1.6 7.33398L2.66667 8.40065L3.73333 7.33398L4.66667 8.26732L3.6 9.33398L4.66667 10.4007L3.73333 11.334L2.66667 10.2673L1.6 11.334ZM9.63333 10.6673C9.3 10.6673 8.99444 10.6034 8.71667 10.4757C8.43889 10.3479 8.2 10.1395 8 9.85065C7.72222 10.0062 7.43611 10.1451 7.14167 10.2673C6.84722 10.3895 6.54444 10.5118 6.23333 10.634L5.76667 9.38398C6.07778 9.27287 6.375 9.15343 6.65833 9.02565C6.94167 8.89787 7.21667 8.76176 7.48333 8.61732C7.42778 8.37287 7.38611 8.10621 7.35833 7.81732C7.33055 7.52843 7.31667 7.21732 7.31667 6.88398C7.31667 5.28398 7.63333 3.95898 8.26667 2.90898C8.9 1.85898 9.69444 1.33398 10.65 1.33398C11.2278 1.33398 11.7 1.54787 12.0667 1.97565C12.4333 2.40343 12.6167 3.00065 12.6167 3.76732C12.6167 4.72287 12.3139 5.66732 11.7083 6.60065C11.1028 7.53398 10.2611 8.37287 9.18333 9.11732C9.26111 9.1951 9.34167 9.25343 9.425 9.29232C9.50833 9.33121 9.59444 9.35065 9.68333 9.35065C9.97222 9.35065 10.3083 9.16732 10.6917 8.80065C11.075 8.43398 11.4222 7.95065 11.7333 7.35065L12.95 7.91732C12.8722 8.10621 12.8111 8.33398 12.7667 8.60065C12.7222 8.86732 12.7278 9.10065 12.7833 9.30065C12.8944 9.2451 13.025 9.15065 13.175 9.01732C13.325 8.88398 13.4778 8.71732 13.6333 8.51732L14.6833 9.33398C14.3944 9.73398 14.0611 10.0562 13.6833 10.3007C13.3056 10.5451 12.9556 10.6673 12.6333 10.6673C12.4 10.6673 12.1917 10.5979 12.0083 10.459C11.825 10.3201 11.6722 10.1062 11.55 9.81732C11.2389 10.0951 10.9222 10.3062 10.6 10.4507C10.2778 10.5951 9.95555 10.6673 9.63333 10.6673Z"
            fill="#4E4B66"
          />
        </svg>
        <Box padding={0.7} />
        {translatedText}
      </Box>
    );
  }
  if (type === ChecklistItemType.MULTI_MEDIA) {
    return (
      <>
        <Box display="flex" alignItems="center">
          <ImageOutlinedIcon fontSize="small" />
          <Box padding={0.7} />
          {translatedText}
        </Box>
        {!closed && (
          <MediaBox>
            <AutoAwesomeOutlinedIcon fontSize="small" />
            {t(`CHECKLIST_ITEM_TYPE.AI`)}
          </MediaBox>
        )}
      </>
    );
  }
  if (type === ChecklistItemType.TIME) {
    return (
      <Box display="flex" alignItems="center">
        <AccessTimeIcon fontSize="small" />
        <Box padding={0.7} />
        {translatedText}
      </Box>
    );
  }
  if (type === ChecklistItemType.YES_NO) {
    return (
      <Box display="flex" alignItems="center">
        <ContrastIcon fontSize="small" />
        <Box padding={0.7} />
        {translatedText}
      </Box>
    );
  }
  if (type === ChecklistItemType.DISCLAIMER) {
    return (
      <Box display="flex" alignItems="center">
        <CheckBoxOutlinedIcon fontSize="small" />
        <Box padding={0.7} />
        {translatedText}
      </Box>
    );
  }
  if (type === ChecklistItemType.DATE) {
    return (
      <Box display="flex" alignItems="center">
        <CalendarTodayOutlinedIcon fontSize="small" />
        <Box padding={0.7} />
        {translatedText}
      </Box>
    );
  }
  if (type) {
    return translatedText;
  }
  return null;
};

export const isShowOptionInput = (type: ChecklistItemType) => {
  return [ChecklistItemType.RADIO_BUTTON, ChecklistItemType.CHECK_BOX].includes(
    type
  );
};

export const numberOfWrappedItems = (flexContainer) => {
  const GAP_WIDTH = 4;
  if (!flexContainer) return;
  const containerWidth = flexContainer.clientWidth;
  let totalWidth = 0;
  let itemCount = 0;

  for (let i = 0; i < flexContainer.children.length; i++) {
    const element = flexContainer.children[i];
    const itemWidth = element.offsetWidth;
    if (totalWidth + itemWidth > containerWidth) {
      itemCount = flexContainer.children.length - i;
      break;
    } else {
      totalWidth += itemWidth + GAP_WIDTH;
    }
  }

  return itemCount;
};

export const toggleHiddenChips = (chipsRef: any, maxHeight: number) => {
  let nOfHiddenItem = 0;
  const validElements = chipsRef?.current?.filter((e) => e !== null);
  validElements?.forEach((e) => {
    if (e.offsetTop + e.offsetHeight > maxHeight + 8) {
      e.classList.remove('visible');
      nOfHiddenItem += 1;
    } else {
      e.classList.add('visible');
    }
  });
  return nOfHiddenItem;
};

export const isMultiChoice = (type: ChecklistItemType) =>
  type === ChecklistItemType.MULTIPLE_CHOICE ||
  type === ChecklistItemType.CHECK_BOX ||
  type === ChecklistItemType.RADIO_BUTTON;

export const isRadioButton = (
  checklistItem: ViewChecklistItem | ReportChecklistItem
) =>
  checklistItem.type == ChecklistItemType.RADIO_BUTTON ||
  (checklistItem.type == ChecklistItemType.MULTIPLE_CHOICE &&
    !checklistItem.allowMultipleOptions);

export const isCheckBox = (checklistItem: ViewChecklistItem) =>
  checklistItem.type == ChecklistItemType.CHECK_BOX ||
  (checklistItem.type == ChecklistItemType.MULTIPLE_CHOICE &&
    checklistItem.allowMultipleOptions);

export const mapChecklistItem = (
  item,
  order = undefined
): ViewChecklistItem => ({
  title: item.title ?? ' ',
  isDeleted: false,
  type: item.type as ChecklistItemType,
  mandatory: item.mandatory,
  checklistItemOptions: item.selectOptions ?? item.checklistItemOptions,
  order: order ?? item.order,
  instruction: item.instruction,
  imageURL: item.imageURL
});
